import styled from 'styled-components';
import { withAccess } from 'presentation/hooks/access';

interface iContainerProps {
  isOpen: boolean;
}

export const Container = styled.div<iContainerProps>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  width: 449px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid #dedede;
`;

export const GeneralData = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 24px;
  border-bottom: 1px solid #dedede;
`;

export const GeneralDataForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Idenfitication = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
`;

export const ContainerInput = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  text-align: right;
  padding-left: 24px;
`;

export const RegisterDate = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 24px;
  border-bottom: 1px solid #dedede;
`;

export const KeyboardDateContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const KeyboardContent = styled.div`
  width: 140px;
`;

export const Permissions = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  border-bottom: 1px solid #dedede;
`;

export const RadioPermissions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerRadioButtons = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const ContentRadioButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid #efefef;
  font-size: 16px;
  font-weight: normal;
  color: #000000;

  .icon {
    position: absolute;
    right: 0;
    margin-right: 10px;
    cursor: pointer;
  }
`;

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
`;

interface iTypographyProps {
  weight?: string;
  size?: string;
  line?: string;
  color?: string;
}

export const Typography = styled.p<iTypographyProps>`
  font-style: normal;
  font-weight: ${({ weight }) => weight || 'normal'};
  font-size: ${({ size }) => size || '16px'};
  line-height: ${({ line }) => line || '19px'};
  color: ${({ color }) => color || '#000000'};
`;

export const FormItem = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 10px;
  justify-content: space-between;
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background-color: #f8f8f8;
  border-top: 1px solid #dedede;
`;

export const Options = styled.option`
  width: 100%;
  min-width: 211px;
  background-color: #ffffff;
  font-style: normal;
  font-weight: normal;
  color: #000000;
  font-size: 16px;
`;

export const ContainerSearch = withAccess(styled.div``);
